export enum PayoutLineItemType {
  RideFare = 1,
  RideAttending = 2,
  SignUpBonus = 3,
  Adjustment = 4,
  ReferralBonus = 5,
  WaitingTime = 6,
  EquipmentEimbursement = 7,
  ServiceProviderAdjustment = 8,
}
